import { render, staticRenderFns } from "./SensorBaseInfo.vue?vue&type=template&id=6be61c26&scoped=true&"
import script from "./SensorBaseInfo.vue?vue&type=script&lang=js&"
export * from "./SensorBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./SensorBaseInfo.vue?vue&type=style&index=0&id=6be61c26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be61c26",
  null
  
)

export default component.exports